import { CUSTOM_DROPDOWN_EVENT, SELECTED_VALUE_CLASSNAME } from '@app/dropdown';

const GLOBAL_CATEGORY_KEY = 'globalCategory';
const CATEGORY_SELECTOR_CLASSNAME = '.global-category-selector';

const DEFAULT_CATEGORY = {
  domainName: 'Global Category 1',
  domainValue: 'category_1',
};

// const showActiveCategoryNavItems = (domainValue: string) => {
//   const categoryNavEls = document.querySelectorAll(
//     '.md-nav__list .md-nav__item[data-global-category]:not([data-global-category=""])'
//   ) as NodeListOf<HTMLLinkElement>;
//
//   categoryNavEls.forEach((categoryNavEl) => {
//     const {
//       dataset: { globalCategory = [] },
//     } = categoryNavEl;
//
//     if ((globalCategory as string[]).includes(domainValue)) {
//       categoryNavEl.classList.remove('hidden');
//     } else {
//       categoryNavEl.classList.add('hidden');
//     }
//   });
// };

export const initGlobalCategory = () => {
  const { domainName, domainValue } =
    JSON.parse(localStorage.getItem(GLOBAL_CATEGORY_KEY) || '""') ||
    DEFAULT_CATEGORY;

  const dropdownValueEl = document.querySelector(
    `${CATEGORY_SELECTOR_CLASSNAME} ${SELECTED_VALUE_CLASSNAME}`
  ) as HTMLSpanElement;

  if (!dropdownValueEl) {
    return;
  }

  // showActiveCategoryNavItems(domainValue);
  dropdownValueEl.textContent = domainName;

  const contentEl = document.querySelector('.md-content') as HTMLElement;
  const {
    dataset: { siteUrl = '', pageGlobalCategory = '' },
  } = contentEl;

  const pageGlobalCategoryArr: string[] = pageGlobalCategory
    ? JSON.parse(pageGlobalCategory.replace(/'/g, '"'))
    : [];

  let globalCategory = { domainName: '', domainValue: '' };

  if (
    pageGlobalCategoryArr?.length &&
    !pageGlobalCategoryArr.includes(domainValue)
  ) {
    const categoryListItemEls = document.querySelectorAll(
      `${CATEGORY_SELECTOR_CLASSNAME} .dropdown-item`
    ) as NodeListOf<HTMLSpanElement>;

    [...categoryListItemEls].forEach((item) => {
      const {
        dataset: { domainName = '', domainValue = '' },
      } = item;

      if (pageGlobalCategoryArr.includes(domainValue)) {
        globalCategory = { domainName, domainValue };

        return false;
      }

      return true;
    });

    // showActiveCategoryNavItems(pageGlobalCategoryArr[0]);
    dropdownValueEl.textContent = globalCategory.domainName;

    localStorage.setItem(GLOBAL_CATEGORY_KEY, JSON.stringify(globalCategory));
  }

  if (dropdownValueEl) {
    dropdownValueEl.addEventListener(CUSTOM_DROPDOWN_EVENT, (({
      detail: { domainName, domainValue, redirectUri },
    }: CustomEvent) => {
      localStorage.setItem(
        GLOBAL_CATEGORY_KEY,
        JSON.stringify({ domainName, domainValue })
      );

      window.location.href = siteUrl + redirectUri;
    }) as EventListener);
  }
};
